import React from "react";
import "./topAchieversDesigns.css";
import {
  buildCategories,
  canViewTopAchievers,
  useTopAchievers,
} from "./topAchieversShared";
// import TopAchieversDesign1 from "./TopAchieversDesign1";
// import TopAchieversDesign2 from "./TopAchieversDesign2";
// import TopAchieversDesign3 from "./TopAchieversDesign3";
import TopAchieversDesign4 from "./TopAchieversDesign4";
// import TopAchieversDesign5 from "./TopAchieversDesign5";

// const DESIGN_OPTIONS = [
//   { id: "design1", label: "Design 1" },
//   { id: "design2", label: "Design 2" },
//   { id: "design3", label: "Design 3" },
//   { id: "design4", label: "Design 4" },
//   { id: "design5", label: "Design 5" },
// ];

const TopAchievers = ({ data, ovalLoading, hasPermission, filter }) => {
  // const [activeDesign, setActiveDesign] = useState("design1");

  const {
    excelLoading,
    selectedWeek,
    weekOptions,
    currentData,
    currentLoading,
    handlePeriodChange,
    downloadExcel,
  } = useTopAchievers({ data, ovalLoading, filter });

  if (!canViewTopAchievers(hasPermission)) return null;

  const activeCategories = buildCategories(currentData).filter((cat) =>
    hasPermission(cat.permission),
  );

  if (activeCategories.length === 0) return null;

  const sharedProps = {
    activeCategories,
    selectedWeek,
    weekOptions,
    currentData,
    currentLoading,
    excelLoading,
    handlePeriodChange,
    downloadExcel,
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        {/* UI Samples Design Switcher Badge Tabs - HIDDEN */}
        {/* <div className="ta-design-switcher-bar">
          <div className="ta-design-switcher-title">
            <i className="bx bx-layout"></i>
            <span>Top Achievers UI Samples</span>
          </div>

          <div className="ta-design-badges-group" role="tablist">
            {DESIGN_OPTIONS.map((design) => {
              const isCurrent = activeDesign === design.id;
              return (
                <button
                  key={design.id}
                  type="button"
                  role="tab"
                  aria-selected={isCurrent}
                  className={`ta-design-badge-btn ${isCurrent ? "is-active" : ""}`}
                  onClick={() => setActiveDesign(design.id)}
                >
                  <i
                    className={
                      isCurrent
                        ? "bx bxs-check-circle"
                        : "bx bx-radio-circle"
                    }
                  ></i>
                  <span>{design.label}</span>
                  {design.tag ? (
                    <span className="ta-badge-tag">{design.tag}</span>
                  ) : null}
                </button>
              );
            })}
          </div>
        </div> */}

        {/* Render Design 4 (Default/Fixed Design) */}
        <TopAchieversDesign4 {...sharedProps} />
        
        {/* Other Designs - Commented Out */}
        {/* {activeDesign === "design1" && <TopAchieversDesign1 {...sharedProps} />} */}
        {/* {activeDesign === "design2" && <TopAchieversDesign2 {...sharedProps} />} */}
        {/* {activeDesign === "design3" && <TopAchieversDesign3 {...sharedProps} />} */}
        {/* {activeDesign === "design5" && <TopAchieversDesign5 {...sharedProps} />} */}
      </div>
    </div>
  );
};

export default TopAchievers;
